export enum ProblemCodeDto {
  MissingTD = 0,
  MissingGTIN = 1,
  MissingArticleNumber = 2,
  MissingProductName = 3
}
